import React, { Fragment } from "react";
import {
  Link,
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
} from "react-router-dom";

export default function Header(props) {
  const navigate = useNavigate();
  return (
    <div className="header_mainContainer">
      <div className="header_innerContainer">
        {props?.navbarMenu?.map((item, index) => {
          return (
            <Fragment key={index}>
              <Link to={item?.pageNavigate} className="headerMenu_Container">
                <div className="headerMenu_InnerContainer">{item.name}</div>
              </Link>
            </Fragment>
          );
        })}
      </div>
    </div>
  );
}

/* <div
              key={item.pageNavigate}
              className="headerMenu_Container"
              onClick={() => navigate(item.pageNavigate)} // ✅ must be ABSOLUTE
            >
              <div className="headerMenu_InnerContainer">{item.name}</div>
            </div> */
